import { render, staticRenderFns } from "./DestinationMailAddress.vue?vue&type=template&id=37bbcfd6&lang=pug"
import script from "./DestinationMailAddress.vue?vue&type=script&lang=js"
export * from "./DestinationMailAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports